var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconText01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.017 160.074 16 16",
    enableBackground: "new 78.017 160.074 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M90.017,165.074v-2h-9v2h1v-1h3v9h-2v1h5v-1h-2v-9h3v1H90.017z M79.017,172.074h-1v4h4v-1h-3V172.074z  M79.017,161.074h3v-1h-4v4h1V161.074z M90.017,160.074v1h3v3h1v-4H90.017z M93.017,175.074h-3v1h4v-4h-1V175.074z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconText01);
export default __webpack_public_path__ + "static/media/icon_text-01.9452186f4c4e9f7cc11d8a61cac0fd12.svg";
export { ForwardRef as ReactComponent };